// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Kazakhstan */
const KZ = /^(?:7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\d{7})$/;

export default KZ;
